import {staticResourcesEndpoint} from "../utils/communication";
import {getCookie} from "../utils/crypto";

export default function HFImage({src, alt, className}: { src: string, alt: string, className: string }) {
    const bool1 = src.startsWith("local:///"), bool2 = src.startsWith(staticResourcesEndpoint)
    if (bool1 || bool2) {
        const token = getCookie("token"),
            source = bool1 ?
                src.replace("local:///cooking", staticResourcesEndpoint + "/static/hfsitedata/cookinghf") + "?token=" + getCookie("token")
                : src + "?token=" + getCookie("token");

        if (!token || token === "") {
            return (<span></span>);
        }

        return (
            <img
                src={source}
                alt={alt} className={className}/>
        );
    } else {
        return (
            <img src={src} alt={alt} className={className}/>
        );
    }
}